import { z } from "zod";
import type { TransformDefinition } from "./transforms";

const SUBSTRING_ARGS = z.tuple([
  z.string(),
  z.number().int().nonnegative(),
  z.number().int().positive(),
]);

/**
 * substring — `(substring value start length)`. Yields `length` characters of
 * `value` starting at the zero-based `start`, for fixed-position fields packed
 * into one source column. Past the end yields what is there (possibly `""`),
 * never an error.
 *
 * `value` is a strict `z.string()` for the same reason as `string_join`: an
 * observe step's column is a parallel array, and only a strict scalar arg
 * pushes evaluation onto the per-item path. Wrap a nullable column in
 * `fallback` first.
 */
export const substringTransform = {
  name: "substring",
  label: "substr",
  description:
    "Yields `length` characters of the first argument, starting at the zero-based `start`.",
  args: SUBSTRING_ARGS,
  output: z.string(),
  evaluate: ([value, start, length]) => value.slice(start, start + length),
} satisfies TransformDefinition<typeof SUBSTRING_ARGS, z.ZodString>;
